export const fullstory = {
  event: (name: string, properties: Record<string, any> = {}) => {
    try {
      window.FS?.event?.(name, properties)
    } catch (error) {
      console.error(`FullStory event "${name}" failed:`, error)
    }
  },

  log: (level: string, message: string) => {
    try {
      window.FS?.log?.(level, message)
    } catch (error) {
      console.error(`FullStory log at level "${level}" failed:`, error)
    }
  },
}
